module.exports = {"150502001":"科尔沁街道","150502002":"西门街道","150502003":"永清街道","150502004":"明仁街道","150502005":"施介街道","150502006":"清真街道","150502007":"东郊街道","150502008":"铁路街道","150502009":"红星街道","150502010":"霍林街道","150502011":"建国街道","150502100":"大林镇","150502101":"钱家店镇","150502102":"余粮堡镇","150502103":"木里图镇","150502104":"丰田镇","150502105":"清河镇","150502106":"育新镇","150502107":"庆和镇","150502108":"敖力布皋镇","150502200":"莫力庙苏木","150502400":"哲南农场","150502401":"三义堂农场","150502402":"高林屯种畜场","150502403":"胡力海原种繁殖场","150502404":"莫力庙羊场","150502405":"半截店牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150502.json
// module id = 427
// module chunks = 0